export default {
  'userManagement.title': '用户列表',
  'userManagement.form.username': '用户名',
  'userManagement.form.username.placeholder': '请输入用户名',
  'userManagement.form.email': '邮箱',
  'userManagement.form.email.placeholder': '请输入邮箱',
  'userManagement.form.phone': '手机号',
  'userManagement.form.phone.placeholder': '请输入手机号',
  'userManagement.form.search': '查询',
  'userManagement.form.reset': '重置',
  'userManagement.operation.add': '新增',
  'userManagement.operation.delete': '删除',
  'userManagement.actions.refresh': '刷新',
  'userManagement.actions.density': '密度',
  'userManagement.actions.columnSetting': '列设置',
  'userManagement.columns.index': '#',
  'userManagement.columns.avatar': '头像',
  'userManagement.columns.username': '用户名',
  'userManagement.columns.nickname': '运营名称',
  'userManagement.columns.merchant': '所属商户',
  'userManagement.columns.role': '角色',
  'userManagement.columns.email': '邮箱',
  'userManagement.columns.phone': '手机号',
  'userManagement.columns.remark': '备注',
  'userManagement.columns.status': '状态',
  'userManagement.columns.createdAt': '创建时间',
  'userManagement.columns.updatedAt': '更新时间',
  'userManagement.columns.status.enabled': '启用',
  'userManagement.columns.status.disabled': '禁用',
  'userManagement.columns.operations': '操作',
  'userManagement.columns.operations.edit': '编辑',
  'userManagement.columns.operations.delete': '删除',
  'userManagement.columns.operations.deleteConfirm': '确定要删除这条记录吗？',
  'userManagement.size.mini': '迷你',
  'userManagement.size.small': '小',
  'userManagement.size.medium': '中',
  'userManagement.size.large': '大',
  'userManagement.modal.title': '新增用户',
  'userManagement.modal.avatar': '头像',
  'userManagement.modal.merchant': '所属商户',
  'userManagement.modal.merchant.placeholder': '请选择商户',
  'userManagement.modal.merchant.required': '请选择所属商户',
  'userManagement.modal.role': '所属角色',
  'userManagement.modal.role.placeholder': '请选择角色',
  'userManagement.modal.role.required': '请选择所属角色',
  'userManagement.modal.username': '用户名',
  'userManagement.modal.username.placeholder': '请输入用户名',
  'userManagement.modal.username.required': '请输入用户名',
  'userManagement.modal.password': '密码',
  'userManagement.modal.password.placeholder': '请输入密码',
  'userManagement.modal.password.required': '请输入密码',
  'userManagement.modal.nickname': '呢称',
  'userManagement.modal.nickname.placeholder': '请输入呢称',
  'userManagement.modal.email': '邮箱',
  'userManagement.modal.email.placeholder': '请输入邮箱',
  'userManagement.modal.phone': '手机',
  'userManagement.modal.phone.placeholder': '请输入手机',
  'userManagement.modal.remark': '备注',
  'userManagement.modal.remark.placeholder': '请输入备注',
  'userManagement.modal.status': '状态',
  'userManagement.modal.status.enabled': '启用',
  'userManagement.modal.status.disabled': '禁用',
  'userManagement.modal.createSuccess': '创建成功',
  'userManagement.modal.createFailed': '创建失败',
  'userManagement.modal.editTitle': '编辑用户',
  'userManagement.modal.password.editPlaceholder': '留空则不修改密码',
  'userManagement.modal.updateSuccess': '更新成功',
  'userManagement.modal.updateFailed': '更新失败',
  'userManagement.operation.deleteSuccess': '删除成功',
  'userManagement.operation.deleteFailed': '删除失败',
  'userManagement.operation.noSelection': '请先选择要操作的用户',
  'userManagement.operation.batchDeleteConfirm': '确定要删除选中的用户吗？',
  'userManagement.operation.batchDeleteSuccess': '批量删除成功',
  'userManagement.operation.batchDeleteFailed': '批量删除失败',
  'userManagement.upload.success': '头像上传成功',
  'userManagement.upload.failed': '头像上传失败',
};

